import type { IInitializeCampaignProduct } from '../hooks/useInitializeCampaignProduct';
import type { ICampaignProduct } from '../types';
import type { ReactNode } from 'react';

import { useInitializeCampaignProduct } from '../hooks/useInitializeCampaignProduct';
import { createContext, useContext, useMemo } from 'react';

export type ICampaignProductContext = IInitializeCampaignProduct;
export interface ICampaignProductProvider {
  children: ReactNode;
  campaignProductId?: ICampaignProduct['id'];
}

export const CampaignProductContext = createContext<ICampaignProductContext | undefined>(undefined);

export const CampaignProductProvider: React.FC<ICampaignProductProvider> = ({
  children,
  campaignProductId,
}) => {
  const internalCampaignProduct = useInitializeCampaignProduct({ campaignProductId });

  const contextValue = useMemo(
    () => ({
      ...internalCampaignProduct,
    }),
    [internalCampaignProduct],
  );

  return (
    <CampaignProductContext.Provider value={contextValue}>
      {children}
    </CampaignProductContext.Provider>
  );
};

export const useCampaignProductContext = () => {
  const context = useContext(CampaignProductContext);
  if (!context) {
    throw new Error('useCampaignProductContext must be used within a CampaignProductProvider');
  }
  return context;
};
